import React, { useContext } from "react";
import { Alert, Container, MantineColor } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { AppContext } from "../../Pages/Wrapper";
import { Colors } from "../../Lib/Data";

interface DisplayAlertProps {
  containerSize?: "xs" | "sm" | "md" | "lg" | "xl";
  containerStyle?: React.CSSProperties;
  Icon?: typeof IconInfoCircle;
  color?: MantineColor;
  children: React.ReactNode;
  title?: string;
}
export default function DisplayAlert({
  containerSize = "sm",
  containerStyle,
  color: c,
  Icon = IconInfoCircle,
  children,
  title = "Alert!",
}: DisplayAlertProps) {
  const context = useContext(AppContext);
  const theme = context?.theme ?? "light";
  const color =
    c ?? theme === "dark" ? "var(--mantine-color-gray-8)" : Colors.BluePrimary;
  return (
    <Container size={containerSize} style={containerStyle}>
      <Alert
        variant={theme === "dark" ? "filled" : "light"}
        color={color}
        title={title}
        icon={<Icon />}
      >
        {children}
      </Alert>
    </Container>
  );
}
